import SectionErrorRoute from 'garaje/utils/section-error-route';

export default class SpacesMapsErrorRoute extends SectionErrorRoute {
  section = 'maps';
}
